<template>

    <div>

        <b-row>

            <b-col class="p-0">

                <multiselect
                    v-model="category"
                    :options="categories"
                    :custom-label="categoriesCustom"
                    track-by="uuid"
                    :multiple="false"
                    :allowEmpty="false"
                    placeholder="Categoría"
                    selectLabel="+"
                    deselectLabel="-">
                    <template slot="singleLabel" slot-scope="props">
                        {{ props.option.name }}
                    </template>
                    <template slot="option" slot-scope="props">
                        <template
                            v-if="!!props.option.depth && props.option.depth>0"
                            v-for="n in props.option.depth">-
                        </template>
                        {{ props.option.name }}
                    </template>
                </multiselect>

            </b-col>

            <b-col class="p-0 pl-2">

                <multiselect
                    v-model="adviser"
                    :options="categoryAdvisers"
                    track-by="uuid"
                    :customLabel="(adviser) => (`${adviser.firstname} ${adviser.lastname}`)"
                    :multiple="false"
                    :allowEmpty="true"
                    placeholder="Asesor"
                    selectLabel="+"
                    deselectLabel="-">
                </multiselect>

            </b-col>

            <b-col class="col-1 p-0 pl-2">
                <button class="btn btn-brand btn-primary" @click.prevent="addCategoryAdviser"><i class="fa fa-plus"></i></button>
            </b-col>

        </b-row>

        <b-row class="mt-2">

            <b-col class="p-0">

                <b-list-group>
                    <b-list-group-item v-for="(categoryAdviser, index) in categoryAdvisersSelected" :key="index">

                        {{ categoryAdviser.category.name }} - {{ categoryAdviser.adviser.name }} {{ categoryAdviser.adviser.firstname }} {{ categoryAdviser.adviser.lastname }}

                        <b-badge @click="removeCategoryAdviser(index)"
                            variant="danger" class="mt-1 float-right" pill>
                            Borrar
                        </b-badge>

                    </b-list-group-item>
                </b-list-group>

            </b-col>

        </b-row>

    </div>

</template>

<script>

    import Multiselect from 'vue-multiselect';
    import {getAdvisers} from '@/api/user-api';
    import {getQueryCategoriesTree} from '@/api/query-category-api';

    export default {

        name: "CategoryAdviserSelector",

        components: {Multiselect},

        props: {
            value: Array,
        },

        data: function () {
            return {
                categories: [],
                category: null,
                advisers: [],
                adviser: null,
                categoryAdvisers: [],
                categoryAdvisersSelected: !!this.value ? this.value : []
            }
        },

        watch: {
            category: function() {
                this.adviser = null;
                if (!!this.category) {
                    this.categoryAdvisers = this.advisers.filter((adviser) => (adviser.specialty.uuid === this.category.parent))
                } else {
                    this.categoryAdvisers = [];
                }
            }
        },

        mounted() {
            this.getQueryCategories();
            this.getAdvisers();
        },

        methods: {

            categoriesCustom(category) {
                if ('depth' in category && category.depth > 0) {
                    return `- ${category.name}`
                } else {
                    return `${category.name}`
                }
            },
            async getAdvisers() {
                await getAdvisers()
                    .then((advisers) => {
                        this.advisers = advisers;
                    })
                    .catch(() => {
                        this.advisers = [];
                    });
            },

            async getQueryCategories() {
                await getQueryCategoriesTree()
                    .then((queryCategories) => {
                        this.categories = queryCategories
                    })
                    .catch(() => {
                        this.categories = [];
                    });
            },

            addCategoryAdviser() {
                if (!this.category || !this.adviser) {
                    return;
                }
                if (this.existsCategoryAdviser(this.adviser.uuid)) {
                    this.$_notificationMixin_warn("Asesor ya incluido", "Tiene que seleccinar un asesor diferente si quiere añadir alguno más.");
                    return;
                }
                this.categoryAdvisersSelected.push({category: this.category, adviser: this.adviser});
                this.$emit('input', this.categoryAdvisersSelected);
                this.category = null;
                this.adviser = null;
            },

            existsCategoryAdviser(adviserUuid) {
                return this.categoryAdvisersSelected.find((categoryAdviser) => {
                    return categoryAdviser.adviser.uuid === adviserUuid
                });
            },

            removeCategoryAdviser(index) {
                this.categoryAdvisersSelected.splice(index, 1);
            }
        }
    }
</script>

<style>
    .badge {
        cursor: pointer !important;
    }
</style>
